import { Card, inputStyle, labelStyle } from "../shared";

export function LateFeeSection({ settings, setSettings }) {
  return (
    <Card style={{ marginBottom: 20 }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16, marginBottom: 6 }}>Late Fee Automation</div>
      <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 16 }}>Automatically mark payments overdue and apply a late fee after a grace period.</div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <input type="checkbox" id="lateFeeEnabled" checked={!!settings.lateFeeEnabled} onChange={e => setSettings(s => ({ ...s, lateFeeEnabled: e.target.checked }))} style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#163C2F" }} />
        <label htmlFor="lateFeeEnabled" style={{ ...labelStyle, marginBottom: 0, cursor: "pointer", fontSize: 13, textTransform: "none", letterSpacing: 0, color: "#163C2F", fontFamily: "'Manrope', sans-serif" }}>Enable automatic late fees</label>
      </div>
      {settings.lateFeeEnabled && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }}>
          <div>
            <label style={labelStyle}>Grace Period (days)</label>
            <input type="number" min="0" max="30" value={settings.lateFeeGraceDays} onChange={e => setSettings(s => ({ ...s, lateFeeGraceDays: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Late Fee Amount ($)</label>
            <input type="number" min="0" value={settings.lateFeeAmount} onChange={e => setSettings(s => ({ ...s, lateFeeAmount: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Default Due Day of Month</label>
            <input type="number" min="1" max="28" value={settings.dueDayOfMonth} onChange={e => setSettings(s => ({ ...s, dueDayOfMonth: e.target.value }))} style={inputStyle} />
          </div>
        </div>
      )}
      {!settings.lateFeeEnabled && (
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Default Due Day of Month</label>
          <input type="number" min="1" max="28" value={settings.dueDayOfMonth} onChange={e => setSettings(s => ({ ...s, dueDayOfMonth: e.target.value }))} style={{ ...inputStyle, maxWidth: 100 }} />
        </div>
      )}
    </Card>
  );
}
